<template>
  <div class="stepper">
    <div
      v-for="(s, idx) in steps"
      :key="s.key"
      class="step"
      :class="{ done: idx < activeIndex, active: idx === activeIndex }"
    >
      <div class="dot">{{ idx + 1 }}</div>
      <div class="label">{{ s.label }}</div>
      <div v-if="idx !== steps.length - 1" class="line"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SemStepper',
  props: {
    activeKey: {
      type: String,
      required: true,
    },
  },
  computed: {
    steps() {
      return [
        { key: 'step1', label: '标尺识别' },
        { key: 'step2', label: 'AI识别与筛选' },
        { key: 'step3', label: '数据统计与导出' },
      ];
    },
    activeIndex() {
      const idx = this.steps.findIndex((s) => s.key === this.activeKey);
      return Math.max(0, idx);
    },
  },
};
</script>

<style scoped>
.stepper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 8px 4px 2px;
}

.step {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #94a3b8;
  font-size: 12px;
}

.dot {
  width: 22px;
  height: 22px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(148, 163, 184, 0.5);
  background: rgba(255, 255, 255, 0.65);
}

.label {
  white-space: nowrap;
}

.line {
  width: 90px;
  height: 2px;
  background: rgba(148, 163, 184, 0.35);
  border-radius: 99px;
  margin-left: 10px;
}

.step.done,
.step.active {
  color: #0f766e;
}

.step.done .dot,
.step.active .dot {
  border-color: rgba(15, 118, 110, 0.65);
}

.step.done .dot {
  background: rgba(15, 118, 110, 0.12);
}

.step.active .dot {
  background: rgba(16, 185, 200, 0.18);
}

.step.done .line {
  background: rgba(15, 118, 110, 0.55);
}
</style>

